var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"26","height":"24","viewBox":"0 0 26 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M23.8002 3.59961L11.2002 20.6996L2.2002 13.4996","stroke":"#6AB148","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }